import { PortableTextComponentProps } from '@portabletext/react'

import { SanityVideoEmbed } from '@data/sanity/queries/types/content'
import { getYouTubeVideoId } from '@lib/video'

const VideoEmbed = ({
  value,
}: PortableTextComponentProps<SanityVideoEmbed>) => {
  switch (value.type) {
    case 'youtube': {
      const { youtubeVideoUrl } = value
      const youtubeVideoId = getYouTubeVideoId(youtubeVideoUrl)

      if (!youtubeVideoId) {
        return null
      }

      return (
        <div className="relative w-full pt-[calc((9/16)*100%)]">
          <div className="absolute inset-0">
            <iframe
              src={`https://www.youtube.com/embed/${youtubeVideoId}`}
              title="YouTube video player"
              allow="encrypted-media"
              allowFullScreen
              width="100%"
              height="100%"
              className="border-0"
            ></iframe>
          </div>
        </div>
      )
    }

    default: {
      return null
    }
  }
}

export default VideoEmbed
